export default class ClockUtils {
    static toolsFrequency(frequency) {
        let frequencyArr = ['日', '一', '二', '三', '四', '五', '六'];
        let string = '';
        if (frequency.length == 7) {
            return '每天'
        } else {
            frequency.forEach((currentValue, index) => {
                string = string ? (string + '、' + frequencyArr[currentValue]) : frequencyArr[currentValue];
            })
            return string
        }
    }

    static getSmallMedia(image, type) {
        if (type == 'photo' && image.indexOf("wxfile://") == -1 && image.indexOf("http://tmp/") == -1) {
            if (image.indexOf("?imageView2")) {
                image = image.split("?imageView2")[0]
            }
            if (image.indexOf("?imageslim")) {
                image = image.split("?imageslim")[0]
            }
            if (image.indexOf("?imageMogr2")) {
                image = image.split("?imageMogr2")[0]
            }
            image = image + "?imageView2/1/w/100";
        } else if (type == 'video') {
            image = image + "?vframe/jpg/offset/0.5";
        }

        return image
    }

    static toolsDay(item) {
        var day = item.day.toString(), month = item.month.toString();
        var monthToString = month.length < 2 ? ('0' + month) : month;
        var dayToString = day.length < 2 ? ('0' + day) : day;

        return (monthToString + '.' + dayToString)
    }

    static toolsDayTime(item) {
        return new Date(item.year, item.month - 1, item.day).getTime();
    }

    static getMonthString(month) {
        var months = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
        return months[month - 1].length > 1 ? months[month - 1] : (months[month - 1] + '月');
    }

    
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockUtils.js